import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Home from "./pages/Home";
import Goals from "./pages/Goals";
import Footer from "./components/Footer";
import Characters from "./pages/Characters";


function App()
{
    return (
        <HashRouter>
            <Navigation />
            <main className="sm:w-[100vw] md:w-[65rem] min-h-vh my-8 md:my-16 mx-auto p-4 md:p-0">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/goals" element={<Goals />} />
                    <Route path="/characters" element={<Characters />} />
                </Routes>
            </main>
            <Footer />
        </HashRouter>
    );
}

export default App;